// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._4bKiABFex{display:flex;flex-direction:column;flex:1;background:#f8f8f8;padding-bottom:40px}._12f6xLJ4x{padding-bottom:40px}._4sQyM2Imx{width:100%;margin-left:auto;margin-right:auto}@media (min-width: 768px){._4sQyM2Imx{max-width:680px}}._4dr408O7x{height:48px;padding:0 20px;border-top:1px solid var(--gray-8);border-bottom:1px solid var(--gray-8);background-color:white}._48YVDAwrx{margin-left:auto;background-color:white}._4tgepWSrx{display:block;text-align:center}._2cqxIwfKx{min-height:initial;flex:1}._2cqxIwfKx>img{height:81px;margin-bottom:20px}._2cqxIwfKx>div[class*=\"empty-state-title-\"]{font-size:20px}._6YvXoucex{display:block}._2j6I150Cx{display:none}._7Ccpbvrsx{}._7Ccpbvrsx{background-color:rgba(0,0,0,0.1);width:100%;margin:4px 0}.cUo11gB3x{height:20px;max-width:300px}._5hMaax14x{background-color:rgba(0,0,0,0.05);height:15px;max-width:200px}._3jdBnT3Zx{display:block;text-align:left;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Helvetica,Ubuntu,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";width:100%;margin-left:auto;margin-right:auto}@media (min-width: 768px){._3jdBnT3Zx{max-width:680px}}._4sQyM2Imx{width:100%;margin-left:auto;margin-right:auto}@media (min-width: 768px){._4sQyM2Imx{max-width:680px}}._6nA8KwTax{padding:0 20px;border-bottom:1px solid var(--gray-8);overflow:hidden;max-width:calc(100vw - 20px * 2)}._1NE2CXjwx{display:flex;margin:16px auto}._4l39OvZAx{font-size:14px}._10BOsvNEx{margin-left:auto;flex:none}._1K9FMg3Xx{margin-right:16px}._71kc2J4sx{font-size:14px;width:100%;margin:16px 0}._71kc2J4sx p{margin:5px 0}._49WV3ZZEx{border-radius:15px;height:32px;text-transform:uppercase;font-size:14px;padding:0 8px;line-height:2}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"releases": "_4bKiABFex",
	"top-release": "_12f6xLJ4x",
	"topRelease": "_12f6xLJ4x",
	"responsive-constraint": "_4sQyM2Imx",
	"responsiveConstraint": "_4sQyM2Imx",
	"title-bar": "_4dr408O7x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"titleBar": "_4dr408O7x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"title-controls": "_48YVDAwrx",
	"titleControls": "_48YVDAwrx",
	"see-all-versions": "_4tgepWSrx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["space-xl-above"] + "",
	"seeAllVersions": "_4tgepWSrx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["space-xl-above"] + "",
	"no-releases": "_2cqxIwfKx",
	"noReleases": "_2cqxIwfKx",
	"visible": "_6YvXoucex",
	"hidden": "_2j6I150Cx",
	"skeleton": "_7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"title-skeleton": "cUo11gB3x _7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"titleSkeleton": "cUo11gB3x _7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"paragraph-skeleton": "_5hMaax14x _7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"paragraphSkeleton": "_5hMaax14x _7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + " _7Ccpbvrsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["skeleton-pulse"] + "",
	"unstyled-button": "_3jdBnT3Zx",
	"unstyledButton": "_3jdBnT3Zx",
	"release": "_6nA8KwTax",
	"release-container": "_1NE2CXjwx",
	"releaseContainer": "_1NE2CXjwx",
	"title": "_4l39OvZAx",
	"action": "_10BOsvNEx",
	"release-info": "_1K9FMg3Xx",
	"releaseInfo": "_1K9FMg3Xx",
	"release-notes": "_71kc2J4sx",
	"releaseNotes": "_71kc2J4sx",
	"install-button": "_49WV3ZZEx",
	"installButton": "_49WV3ZZEx"
};
module.exports = exports;
